// Only these public landing pages belong in search and the sitemap.
export const publicPaths = ["/", "/buff", "/couples", "/naruto"];

export const isPublicPath = (pathname) => {
    const path = pathname.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
    return publicPaths.includes(path);
};
